module.exports = __webpack_public_path__ + "static/media/gramophone.0773c152.svg";